import { useState } from 'react';
import { FaInstagram, FaYoutube, FaWhatsapp, FaPaperPlane } from 'react-icons/fa';
import { subscribe } from '../../services/subscriptionService';

export default function CommunityNewsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setStatus('error');
      setMessage('Por favor ingresa tu correo electrónico.');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      await subscribe(email, 'home-newsletter');
      setStatus('success');
      setMessage('¡Listo! Te enviaremos novedades y ofertas exclusivas.');
      setEmail('');
    } catch {
      setStatus('error');
      setMessage('Error al procesar tu solicitud. Intenta de nuevo.');
    }
  };

  return (
    <section className="df-section bg-df-bg relative overflow-hidden">
      {/* Background accents */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(139,92,246,0.06)_0%,transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(34,211,238,0.06)_0%,transparent_50%)]" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Two-column layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            {/* Left: Community */}
            <div>
              <h2 className="font-cinzel text-3xl md:text-4xl font-bold text-df-text mb-4">
                Únete a la{' '}
                <span className="text-df-accent">comunidad</span>
              </h2>
              <p className="text-df-muted mb-8 leading-relaxed">
                Conéctate con otros jugadores, comparte estrategias y entérate de
                eventos, lanzamientos y descuentos exclusivos.
              </p>

              {/* Social links */}
              <div className="flex gap-4">
                <a
                  href="https://www.instagram.com/tablero_infinito/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-xl bg-df-surface border border-df-border flex items-center justify-center text-df-muted hover:text-pink-400 hover:border-pink-400 transition-all duration-200"
                  aria-label="Instagram"
                >
                  <FaInstagram className="text-xl" />
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-xl bg-df-surface border border-df-border flex items-center justify-center text-df-muted hover:text-red-400 hover:border-red-400 transition-all duration-200"
                  aria-label="YouTube"
                >
                  <FaYoutube className="text-xl" />
                </a>
                <a
                  href="https://wa.me/573021124424"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-xl bg-df-surface border border-df-border flex items-center justify-center text-df-muted hover:text-green-400 hover:border-green-400 transition-all duration-200"
                  aria-label="WhatsApp"
                >
                  <FaWhatsapp className="text-xl" />
                </a>
              </div>
            </div>

            {/* Right: Newsletter */}
            <div className="df-card p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-df-accent/20 flex items-center justify-center">
                  <FaPaperPlane className="text-df-accent" />
                </div>
                <h3 className="text-xl font-semibold text-df-text font-sans">
                  Newsletter
                </h3>
              </div>
              <p className="text-df-muted text-sm mb-6">
                Recibe ofertas exclusivas, lanzamientos y promociones en tu correo.
              </p>

              <form onSubmit={handleSubmit} className="space-y-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tucorreo@email.com"
                  className="w-full px-4 py-3 rounded-lg bg-df-surface2 border border-df-border text-df-text placeholder-df-muted/50 focus:outline-none focus:ring-2 focus:ring-df-accent focus:border-transparent transition-all"
                  disabled={status === 'loading'}
                  required
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="w-full py-3 bg-df-accent-strong hover:bg-df-accent-deep text-white font-semibold rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {status === 'loading' ? 'Enviando...' : 'Suscribirme'}
                </button>
                {message && (
                  <p
                    className={`text-sm text-center ${
                      status === 'error' ? 'text-df-danger' : 'text-emerald-400'
                    }`}
                  >
                    {message}
                  </p>
                )}
              </form>

              <p className="text-xs text-df-muted/60 mt-3 text-center">
                No compartimos tu información. Respetamos tu privacidad.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
